import openWindow from './openWindow';
export default {
  ...openWindow,
};
